<template>
  <IziGrid class="info-profile">
    <Izi-Col xl="2" />
    <Izi-Col xl="8">
      <IziGrid>
        <IziCol class="col-avatar">
          <Avatar :src="currentUser.photoURL || defaultAvatar" />
        </IziCol>
        <IziCol>
          <IziGrid>
            <IziCol>
              <Izi-Input
                label="Username"
                v-model:value="currentUser.displayName"
                :disabled="true"
              />
            </IziCol>
            <IziCol>
              <Izi-Input
                label="Email"
                v-model:value="currentUser.email"
                :disabled="true"
              />
            </IziCol>
            <IziCol>
              <Izi-Input value="* * * * * * * *" :disabled="true" />
            </IziCol>
          </IziGrid>
        </IziCol>
      </IziGrid>
    </Izi-Col>
    <Izi-Col xl="2" />
  </IziGrid>
</template>
<script lang="ts">
import Base from "../../base/Base.vue";
export default class InfoProfile extends Base {}
</script>

<style lang="scss">
.info-profile {
  padding: 100px;
  .col-avatar {
    text-align: center;
  }
}
</style>
